import { render, staticRenderFns } from "./BetLimits.vue?vue&type=template&id=61ed88d6&"
import script from "./BetLimits.vue?vue&type=script&lang=js&"
export * from "./BetLimits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports